import {IMobilityState} from '../state'
import {initialState} from '../state/initial-state'
import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadMaximActivitiesAction,
  ILoadMaximActivitiesErrorAction,
  ILoadMaximActivitiesSuccessAction,
} from '../actions/load-maxim-activities'

export type LoadMaximActivitiesAction =
  | ILoadMaximActivitiesAction
  | ILoadMaximActivitiesSuccessAction
  | ILoadMaximActivitiesErrorAction

const init = (state: IMobilityState, action: LoadMaximActivitiesAction) => ({
  ...state,
  maximActivities: {
    data: {activities: [], totalCount: '', pagination: {pageIndex: 2, pageSize: 2}},
    companyId: state.maximActivities.companyId,
    status: action.status,
  },
})

const success = (state: IMobilityState, action: LoadMaximActivitiesAction) => ({
  ...state,
  maximActivities: {
    ...initialState.maximActivities,
    status: action.status,
    data: (action as ILoadMaximActivitiesSuccessAction).data,
  },
})

const failure = (state: IMobilityState, action: LoadMaximActivitiesAction) => ({
  ...state,
  maximActivities: {
    ...initialState.maximActivities,
    status: action.status,
    error: (action as ILoadMaximActivitiesErrorAction).error,
  },
})

export const loadMaximActivitiesReducer = createAsyncReducer(initialState, init, success, failure)
